import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { OsApiAuthService } from '../../../services/api-auth/os-api-auth.service';

@Component({
    selector: 'osc-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.css'],
})
export class LogoutComponent {
    public constructor(
        private authService: OsApiAuthService,
        private router: Router
    ) {
        this.authService.clearSessionAfterOAuthLogout().subscribe({
            next: () => this.router.navigate(['/']),
            error: () => this.router.navigate(['/']),
        });
    }
}
